import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";

const DeleteModal = ({ show, onHide, onConfirm, status }) => {
  const isLoading = status === "loading";
  const isSuccess = status === "success";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="border-0 rounded-4 shadow-lg overflow-hidden"
    >
      {/* Top Gradient Bar */}
      <div
        style={{
          height: "6px",
          background: "linear-gradient(to right, #1E0959, #F4C430)",
        }}
      />

      <Modal.Body className="text-center p-4 bg-white">
        {/* Icon Section */}
        <div
          className="d-flex align-items-center justify-content-center mx-auto mb-4"
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            background: "#f3f4f6",
          }}
        >
          {isLoading && <Spinner animation="border" variant="danger" />}

          {isSuccess && <FaCheckCircle size={40} color="#16a34a" />}

          {!isLoading && !isSuccess && (
            <lord-icon
              src="https://cdn.lordicon.com/jzinekkv.json"
              trigger="loop"
              stroke="bold"
              colors="primary:#1e0959,secondary:#f4c430"
              style={{ width: "70px", height: "70px" }}
            ></lord-icon>
          )}
        </div>

        {/* Text Section */}
        {!isSuccess && (
          <>
            <h5 className="fw-bold mb-3">
              {isLoading ? "Deleting..." : "Delete this item?"}
            </h5>

            <p className="text-muted fs-6 mb-4 px-md-4">
              This action is permanent and cannot be undone. Please confirm to
              proceed.
            </p>
          </>
        )}

        {isSuccess && (
          <>
            <h5 className="fw-bold text-success mb-2">Deleted Successfully</h5>
            <p className="text-muted">The item has been removed.</p>
          </>
        )}

        {/* Buttons */}
        {!isLoading && !isSuccess && (
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              variant="outline-secondary"
              onClick={onHide}
              className="px-4 rounded-4"
            >
              Cancel
            </Button>

            <Button
              onClick={onConfirm}
              className="px-4 rounded-4 text-white border-0"
              style={{
                background: "linear-gradient(to right, #F4C430 , #1E0959)",
              }}
            >
              Delete
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
